(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-details"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function () {

  /* -----------------------------------------------------------
     ACCORDION
  ----------------------------------------------------------- */

  document.querySelectorAll(".nh-acc-title").forEach(function (btn) {
    btn.addEventListener("click", function () {
      const item = btn.closest(".nh-acc-item");
      const content = item && item.querySelector(".nh-acc-content");
      if (!item || !content) return;

      const isOpen = item.classList.contains("is-open");

      if (isOpen) {
        // KAPAT
        content.style.maxHeight = content.scrollHeight + 40 + "px";

        requestAnimationFrame(() => {
          content.style.maxHeight = "0px";
          content.style.paddingTop = "0px";
          content.style.paddingBottom = "0px";
        });

        item.classList.remove("is-open");
      } else {
        // AÇ
        item.classList.add("is-open");
        content.style.paddingTop = "12px";
        content.style.paddingBottom = "20px";

        const fullHeight = content.scrollHeight + 40;
        content.style.maxHeight = fullHeight + "px";

        const onEnd = () => {
          if (item.classList.contains("is-open")) {
            content.style.maxHeight = "none";
          }
          content.removeEventListener("transitionend", onEnd);
        };

        content.addEventListener("transitionend", onEnd);
      }
    });
  });

  // Sayfa yüklenirken açık olan item'i gerçekten açık yap
  document
    .querySelectorAll(".nh-acc-item.is-open .nh-acc-content")
    .forEach((content) => {
      content.style.paddingTop = "12px";
      content.style.paddingBottom = "20px";
      content.style.maxHeight = content.scrollHeight + 40 + "px";

      const end = () => {
        content.style.maxHeight = "none";
        content.removeEventListener("transitionend", end);
      };

      content.addEventListener("transitionend", end);
    });

  /* -----------------------------------------------------------
   DESCRIPTION SHOW MORE
   - Sadece product.json şablonunda çalışsın
   - product.empty-meta.json'da çalışmasın
----------------------------------------------------------- */

const showMoreBtn = document.querySelector(".nh-desc-show-more");

if (showMoreBtn) {
  const shortEl = document.querySelector(".nh-desc-short");
  const fullEl = document.querySelector(".nh-desc-full");

  if (shortEl && fullEl) {
    // Eğer shortEl ve fullEl varsa, bu product.json şablonudur
    fullEl.style.display = "none";
    shortEl.style.display = "block";

    showMoreBtn.addEventListener("click", function () {
      const expanded = fullEl.style.display === "block";

      if (expanded) {
        fullEl.style.display = "none";
        shortEl.style.display = "block";
        showMoreBtn.textContent =
          showMoreBtn.getAttribute("data-more-label") || "Show more";
      } else {
        shortEl.style.display = "none";
        fullEl.style.display = "block";
        showMoreBtn.textContent =
          showMoreBtn.getAttribute("data-less-label") || "Show less";
      }
    });
  }
}

  /* -----------------------------------------------------------
     GLOBAL SIZE DRAWER
     - Overlay & Drawer JS ile body'nin SONUNA EKLENİR
     - Header / You may also like bozulmaz
  ----------------------------------------------------------- */

  const sizeButtons = document.querySelectorAll(".nh-size-open");
  const sourceBox = document.getElementById("nh-size-drawer-source");

  if (!sizeButtons.length || !sourceBox) {
    return;
  }

  // Drawer + Overlay DOM'da YOKSA oluştur ve body'nin sonuna ekle
  let overlay = document.querySelector(".nh-size-overlay");
  let drawer = document.querySelector(".nh-size-drawer");

  if (!overlay) {
    overlay = document.createElement("div");
    overlay.className = "nh-size-overlay";
    document.body.appendChild(overlay);
  } else if (!overlay.parentElement || overlay.parentElement.tagName !== "BODY") {
    document.body.appendChild(overlay);
  }

  if (!drawer) {
    drawer = document.createElement("div");
    drawer.className = "nh-size-drawer";

    drawer.innerHTML = `
      <div class="nh-size-drawer-inner">
        <button type="button" class="nh-size-close" aria-label="Close size table">&times;</button>
        <div id="nh-size-drawer-content"></div>
      </div>
    `;

    document.body.appendChild(drawer);
  } else if (!drawer.parentElement || drawer.parentElement.tagName !== "BODY") {
    document.body.appendChild(drawer);
  }

  const closeBtn = drawer.querySelector(".nh-size-close");
  const contentBox = drawer.querySelector("#nh-size-drawer-content");

  if (!contentBox) return;

  function openDrawer() {
    drawer.classList.add("is-open");
    overlay.classList.add("is-visible");
    document.body.classList.add("nh-drawer-open");
  }

  function closeDrawer() {
    drawer.classList.remove("is-open");
    overlay.classList.remove("is-visible");
    document.body.classList.remove("nh-drawer-open");
  }

  // ESC ile kapama
  document.addEventListener("keyup", function (e) {
    if (e.key === "Escape") {
      if (drawer.classList.contains("is-open")) {
        closeDrawer();
      }
    }
  });

  // Butonlara tıklanınca drawer'ı aç ve metafield HTML'ini yükle
  sizeButtons.forEach((btn) => {
    btn.addEventListener("click", function (e) {
      e.preventDefault();

      let html = sourceBox.innerHTML.trim();
      if (!html) {
        html = "<p>No size table added.</p>";
      }
      contentBox.innerHTML = html;

      openDrawer();
    });
  });

  if (closeBtn) {
    closeBtn.addEventListener("click", function () {
      closeDrawer();
    });
  }

  if (overlay) {
    overlay.addEventListener("click", function () {
      closeDrawer();
    });
  }
});
  } catch(e) { console.error(e); }
})();

})();
